<div class="admin-container">
  <div class="card border-0 p-3">
    <app-grid-table
      [datasource]="datasource"
      [rowModelType]="'infinite'"
      [columns]="columns"
      [title]="'admin.sideNav.entities.legalEntities' | translate"
      detailsBaseRoute="/admin/legal-entities"
      [loading]="isLoading()"
      (searchChange)="onSearchChange($event)"
    />
  </div>
</div>
